// extracted by mini-css-extract-plugin
module.exports = {"title":"TitleInner_title__1w3MJ"};